// extracted by mini-css-extract-plugin
module.exports = {"page-primary-color":"#021135","pagePrimaryColor":"#021135","badge":"_23BJ5 undefined"};